import React from "react";
import { Helmet } from "react-helmet-async";
import site from "../data/site";

const SEO = ({ title, description }) => {
  const fullTitle = title ? `${title} · ${site.brand}` : `${site.brand} — Technology & Internet Services`;
  const desc = description || site.shortPitch;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SEO;
